import type React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';

export const PrivacyPage: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#080810',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '60px 20px', flex: 1 }}>
        <Link
          to="/"
          style={{
            color: '#00ff00',
            textDecoration: 'none',
            fontVariantCaps: 'all-petite-caps',
            letterSpacing: 1,
            fontWeight: 600,
          }}
        >
          ← Back to Home
        </Link>
        <h1
          style={{
            marginTop: 24,
            fontVariantCaps: 'all-petite-caps',
            fontSize: '2.5rem',
            color: '#ff2d95',
          }}
        >
          Privacy Policy / Datenschutzerklärung
        </h1>

        <section style={{ marginTop: 32, lineHeight: 1.7, color: 'rgba(255,255,255,0.85)' }}>
          <h2 style={{ fontSize: '1.3rem', color: '#00ff00', fontVariantCaps: 'all-petite-caps' }}>
            1. Data Controller
          </h2>
          <p>
            The data controller responsible for processing data on this website is:
            <br />
            Fabian Althaus (Joev Noise), Berlin, Germany.
            <br />
            Email: f.althaus [at] joev.de
          </p>

          <h2
            style={{
              fontSize: '1.3rem',
              color: '#00ff00',
              fontVariantCaps: 'all-petite-caps',
              marginTop: 28,
            }}
          >
            2. Static Hosting (GitHub Pages)
          </h2>
          <p>
            This website is hosted statically via GitHub Pages (GitHub Inc., 88 Colin P Kelly Jr St,
            San Francisco, CA 94107, USA). When you visit the site, GitHub automatically collects
            server log data (including IP address, browser type, referrer, timestamp). This
            processing is based on Art. 6(1)(f) GDPR (legitimate interest in secure and reliable
            site operation).
          </p>

          <h2
            style={{
              fontSize: '1.3rem',
              color: '#00ff00',
              fontVariantCaps: 'all-petite-caps',
              marginTop: 28,
            }}
          >
            3. Third-Party Embeds &amp; External Media
          </h2>
          <p>
            <strong>SoundCloud:</strong> We integrate the official SoundCloud Widget API for audio
            preview playback. Audio requests and interactions with the SoundCloud player connect to
            SoundCloud Global Limited &amp; Co. KG servers.
            <br />
            <br />
            <strong>YouTube:</strong> Video embeds utilize the privacy-enhanced mode (
            <code>youtube-nocookie.com</code>) to minimize tracking cookies until active playback is
            initiated.
            <br />
            <br />
            <strong>Bandcamp &amp; Telegram:</strong> External links redirect directly to respective
            artist platforms.
          </p>

          <h2
            style={{
              fontSize: '1.3rem',
              color: '#00ff00',
              fontVariantCaps: 'all-petite-caps',
              marginTop: 28,
            }}
          >
            4. Your Rights under GDPR
          </h2>
          <p>
            You have the right to request access, correction, erasure, and restriction of your
            personal data, as well as the right to lodge a complaint with a supervisory authority
            under GDPR.
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
